import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { FormControl, InputLabel, Typography } from "@mui/material";
import React from "react";

export default function AppSearchField({
    onChange,
    value,
    label,
    size = "large",
}) {
    const [focused, setFocused] = React.useState(false);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <FormControl
                size={size}
                variant="outlined"
                sx={{
                    "& .MuiFormLabel-root": {
                        left: "30px",
                    },
                    "& .MuiFormLabel-root.MuiInputLabel-shrink": {
                        left: "10px",
                    },
                }}
            >
                <InputLabel
                    htmlFor="outlined-adornment"
                    shrink={focused || Boolean(value)}
                >
                    {label}
                </InputLabel>
                <OutlinedInput
                    id="outlined-adornment"
                    type="text"
                    fullWidth
                    label={label}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    notched={focused || Boolean(value)}
                    onClick={() => setFocused(true)}
                    onFocus={() => setFocused(true)}
                    onBlur={() => setFocused(false)}
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    }
                    endAdornment={
                        value ? (
                            <InputAdornment
                                position="end"
                                onClick={() => onChange("")}
                            >
                                <CancelOutlinedIcon />
                            </InputAdornment>
                        ) : null
                    }
                />
            </FormControl>
            <Typography
                sx={{ fontSize: "0.87rem", color: "#7E7E81", padding: "8px 0" }}
            >
                برای جست‌وجو از کلید‌واژه‌های دقیق استفاده کنید
            </Typography>
        </Box>
    );
}
